import { FC, memo } from 'react';
import { Button as AntdButton } from 'antd';
import type { ButtonProps as AntdButtonProps } from 'antd';
import MenuButton from './MenuButton';
import FloatButton from './FloatButton';
import TipButton from './TipButton';

export type ButtonPropsType = AntdButtonProps & {
    authCode?: string;
};

const ButtonComponent: FC<ButtonPropsType> = memo((props) => {
    const {
        autoInsertSpace = false,
        authCode = '',
        ...rest
    } = props;

    return (
        <>
            {
                authCode
                ? (
                    <AntdButton {...rest} />
                )
                : (
                    <AntdButton autoInsertSpace={autoInsertSpace} {...rest} />
                )
            }
        </>
    );
});

type CompoundedComponent = FC<ButtonPropsType> & {
    MenuButton: typeof MenuButton;
    FloatButton: typeof FloatButton;
    TipButton: typeof TipButton;
};

const Button = ButtonComponent as CompoundedComponent;
Button.MenuButton = MenuButton;
Button.FloatButton = FloatButton;
Button.TipButton = TipButton;

export default Button;
